export const BASE_PATH = '/';
export const DEVICE_DETAIL_PATH = '/device/:id';
export const DEVICE_SETUP_PATH = '/setup/device';
export const NETWORK_SETUP_PATH = '/setup/network';
export const ERROR_PATH = '/something-went-wrong';
export const WHATS_COVERED_PATH = '/whats-covered';
export const FAQ_PATH = '/faq';
export const UPGRADE_PATH = '/upgrade';
